import domainRegisterBR from './domainRegister.br';
import domainRegisterMX from './domainRegister.mx';
import domainRegisterCL from './domainRegister.cl';
import domainRegisterCO from './domainRegister.co';

const domainRegister = {
  BR: domainRegisterBR,
  MX: domainRegisterMX,
  CL: domainRegisterCL,
  CO: domainRegisterCO,
};

export default domainRegister;
